module.exports = __webpack_public_path__ + "static/lemonanimal4-ebc6069054a2572de81b93ef32a04623.png";